/**
 * SmtpSetting(送信元)関連のStoreで使用するStateをここで定義する
 *
 * Copyright (c) 2018-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'

const OptionState = {
  parent_id: null,
  parent_name: null,
  label: null,
  value: null
}

class AccountTitleOptionState extends Record(OptionState) {
  mergeModel(model) {
    return this.merge({
      parent_id: model.account_title_group_id,
      parent_name: model.account_title_group_name,
      label: model.name,
      value: model.id
    })
  }
}

export default AccountTitleOptionState
